import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { InfoPanelDetailDescription } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/IntoPanelDetailDescription";
import { InfoPanelDetailTitle } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/IntoPanelDetailTitle";
export const InfoPanelDetailValue = /*#__PURE__*/ memo((param)=>{
    let { additionalInfo, value } = param;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(InfoPanelDetailTitle, {
                children: value
            }),
            !!additionalInfo && /*#__PURE__*/ _jsx(InfoPanelDetailDescription, {
                children: additionalInfo
            })
        ]
    });
});
InfoPanelDetailValue.displayName = "InfoPanelDetailValue";
